import { Checkbox, Group } from '@optiaxiom/react';
import { createColumnHelper } from '@tanstack/react-table';

import type { Notification } from '../../types/notification';

import { ActionsCell } from './cells/ActionsCell';
import { CategoryCell } from './cells/CategoryCell';
import { NotificationCell } from './cells/NotificationCell';
import { PriorityCell } from './cells/PriorityCell';
import { TimestampCell } from './cells/TimestampCell';
import { UnreadIndicatorCell } from './cells/UnreadIndicatorCell';

const columnHelper = createColumnHelper<Notification>();

type ColumnCallbacks = {
  onActivate: (notification: Notification) => void;
  onMarkRead: (id: string) => void;
  onMarkUnread: (id: string) => void;
  onDelete: (id: string) => void;
};

export function createColumns(callbacks: ColumnCallbacks) {
  return [
    columnHelper.display({
      id: 'select',
      cell: ({ row }) => (
        <Group gap="8" alignItems="center">
          <UnreadIndicatorCell isRead={row.original.is_read} />
          <Checkbox
            checked={row.getIsSelected()}
            onCheckedChange={() => row.toggleSelected()}
            aria-label={row.getIsSelected() ? 'Unselect notification' : 'Select notification'}
          />
        </Group>
      ),
      header: ({ table }) => (
        <Group gap="8" alignItems="center">
          <UnreadIndicatorCell isRead />
          <Checkbox
            checked={table.getIsAllPageRowsSelected()}
            indeterminate={table.getIsSomePageRowsSelected()}
            onCheckedChange={value => table.toggleAllPageRowsSelected(!!value)}
            aria-label="Select all notifications"
          />
        </Group>
      ),
      size: 64,
    }),
    columnHelper.display({
      id: 'notification',
      header: 'Notification',
      cell: ({ row }) => (
        <NotificationCell
          notification={row.original}
          onActivate={() => callbacks.onActivate(row.original)}
        />
      ),
      size: 700,
    }),
    columnHelper.display({
      id: 'category',
      header: 'Category',
      cell: ({ row }) => <CategoryCell notification={row.original} />,
      size: 150,
    }),
    columnHelper.accessor('created_at', {
      header: 'Timestamp',
      cell: ({ getValue }) => <TimestampCell createdAt={new Date(getValue())} />,
      size: 80,
    }),
    columnHelper.display({
      id: 'priority',
      header: 'Priority',
      cell: ({ row }) => <PriorityCell notification={row.original} />,
      size: 80,
    }),
    columnHelper.display({
      id: 'actions',
      cell: ({ row }) => (
        <ActionsCell
          notification={row.original}
          onMarkRead={callbacks.onMarkRead}
          onMarkUnread={callbacks.onMarkUnread}
          onDelete={callbacks.onDelete}
        />
      ),
      size: 60,
    }),
  ];
}
